import appConfig from '../app-config';
import { apiCall } from './api';

const hostname = appConfig.api.imagesMetadata;

export const apiImagesMetadata = async () => {
    const results = await apiCall(hostname, 'photos.json', 'GET');
  
    return results.data;
};
